import clsx from "clsx"
import React from "react"

import type { TagProps } from "./types"
import type { Label as LabelNative } from "../../Typography/Label/Label.native"
import type { Label as LabelReact } from "../../Typography/Label/Label.react"
import type { Label as LabelWeb } from "../../Typography/Label/Label.web"

type LabelComponent = typeof LabelNative | typeof LabelReact | typeof LabelWeb

export const createTagLabel = (Label: LabelComponent) => {
  const TagLabel = ({ size = "large", bgColor, text }: TagProps) => {
    return (
      <Label
        leading="normal"
        numberOfLines={1}
        size={size === "large" ? 2 : 3}
        className={[
          clsx({
            "text-white": bgColor === "orange",
            "text-neutral-700": bgColor === "lightGrey",
            "text-neutral-900": bgColor !== "orange" && bgColor !== "lightGrey",
          }),
        ]}>
        {text}
      </Label>
    )
  }
  return TagLabel
}
